import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 7C7.48716 7 7.06449 7.38604 7.00673 7.88338L7 8V11C7 11.5523 7.44772 12 8 12C8.51284 12 8.93551 11.614 8.99327 11.1166L9 11V8C9 7.44772 8.55228 7 8 7ZM7 4H9V6H7V4Z",
		fill: "currentColor"
	})
});
export default SvgInfo;
